import styled from 'styled-components';

export const LoadingOverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: $white;
  opacity: 0.5;
  position: absolute;
  top: calc(50% + 80px);
  left: 50%;
  transform: translate(-50%, -50%);
  min-height: 80px;
`;

export const LoaderInner = styled.div`
  display: flex;
  justify-content: center;
  padding: 25px 0;
  height: calc(100% - 75px);
  align-items: center;
`;
